import React from 'react'

import { Text } from '@hhgtech/hhg-components/mantine'
import { Stack } from '@mantine/core'
import { useIntl } from 'react-intl'

export const _NothingFound = React.memo(function __NothingFound() {
  const { formatMessage: f } = useIntl()
  return (
    <Stack align="center" justify="center" py={40}>
      <svg width="120" height="121" viewBox="0 0 120 121" fill="none">
        <g clipPath="url(#clip0_4315_31345)">
          <path
            d="M59.9994 120.013C93.1362 120.013 119.999 93.1503 119.999 60.0136C119.999 26.8768 93.1362 0.0141602 59.9994 0.0141602C26.8626 0.0141602 0 26.8768 0 60.0136C0 93.1503 26.8626 120.013 59.9994 120.013Z"
            fill="#F7F9FC"
          />
          <path
            d="M100.965 79.5097C102.733 79.9785 104.271 81.0752 105.29 82.5948C106.309 84.1145 106.74 85.9532 106.503 87.7675C106.265 89.5818 105.375 91.2475 103.999 92.4535C102.623 93.6596 100.855 94.3234 99.0253 94.321C97.1955 94.3186 95.4292 93.6501 94.0564 92.4404C92.6835 91.2308 91.7979 89.5627 91.5651 87.7478C91.3323 85.9329 91.7682 84.0953 92.7914 82.5784C93.8145 81.0614 95.355 79.9688 97.1249 79.5047C97.7451 79.3377 98.3844 79.2526 99.0267 79.2515C99.6815 79.2487 100.334 79.3355 100.965 79.5097Z"
            fill="#2D87F3"
          />
          <path
            d="M100.965 55.7018V86.0017C100.971 86.4643 100.803 86.9124 100.496 87.2581C100.188 87.6038 99.7629 87.8223 99.3027 87.8706C99.2065 87.879 99.1129 87.8832 99.0251 87.8832H98.9188C98.4331 87.8631 97.9743 87.6548 97.6395 87.3023C97.3047 86.9499 97.1202 86.481 97.125 85.9949V55.7043C97.125 51.181 93.2066 47.5031 88.3854 47.5031C83.5643 47.5031 79.6459 51.181 79.6459 55.7043L79.6366 84.1893C79.6273 96.3672 69.245 106.269 56.4816 106.269C43.7182 106.269 33.3257 96.3545 33.3257 84.1775V63.6297C33.9261 63.9141 34.5821 64.0617 35.2465 64.0617C35.9108 64.0617 36.5669 63.9141 37.1673 63.6297V84.1775C37.1673 94.2418 45.8301 102.424 56.4799 102.424C67.1297 102.424 75.7933 94.2401 75.7933 84.1868L75.8026 55.7018C75.8026 49.0657 81.4498 43.6589 88.3838 43.6589C95.3177 43.6589 100.965 49.0657 100.965 55.7018Z"
            fill="#BCDEFF"
          />
          <path
            d="M39.1838 57.7791V63.2204C39.1615 63.8512 38.9599 64.4625 38.6028 64.983C38.2457 65.5034 37.7478 65.9114 37.1673 66.1592C36.5669 66.4436 35.9108 66.5912 35.2465 66.5912C34.5821 66.5912 33.9261 66.4436 33.3257 66.1592C33.0148 66.0109 32.7241 65.8235 32.4608 65.6015C32.1073 65.3124 31.8213 64.9495 31.6229 64.5381C31.4245 64.1268 31.3186 63.677 31.3125 63.2204V57.9326C32.4326 58.0648 33.5596 58.1291 34.6875 58.125C36.193 58.127 37.6964 58.0114 39.1838 57.7791Z"
            fill="#2D87F3"
          />
          <path
            d="M50.2025 13.7622V19.822H48.9225C48.1189 19.822 47.3482 19.5028 46.78 18.9346C46.2118 18.3664 45.8926 17.5957 45.8926 16.7921C45.8926 15.9885 46.2118 15.2179 46.78 14.6496C47.3482 14.0814 48.1189 13.7622 48.9225 13.7622H50.2025Z"
            fill="#284A75"
          />
          <path
            d="M22.6075 14.6456C23.0334 15.0688 23.3239 15.609 23.4421 16.1976C23.5603 16.7862 23.5009 17.3967 23.2714 17.9514C23.0419 18.5062 22.6527 18.9802 22.1532 19.3133C21.6537 19.6464 21.0665 19.8234 20.4661 19.822H19.0781V13.7622H20.4661C20.8636 13.7613 21.2574 13.8389 21.6249 13.9905C21.9923 14.1421 22.3263 14.3647 22.6075 14.6456Z"
            fill="#284A75"
          />
          <path
            d="M55.9501 18.7851V39.2409C55.9501 51.8415 48.4407 58.0161 39.1822 59.4665C37.6953 59.6987 36.1925 59.8143 34.6876 59.8124C33.5597 59.8165 32.4327 59.7522 31.3126 59.62C21.5512 58.5063 13.436 52.341 13.436 39.2409V18.7851C13.436 14.4347 16.7402 13.7622 18.7567 13.7622H19.4157V39.2435C19.4157 49.1263 26.2636 53.8319 34.6876 53.8319C43.1116 53.8319 49.967 49.1263 49.967 39.2435V13.7622H50.6344C52.6485 13.7622 55.9501 14.4347 55.9501 18.7851Z"
            fill="#2D87F3"
          />
        </g>
        <defs>
          <clipPath id="clip0_4315_31345">
            <rect
              width="120"
              height="120"
              fill="white"
              transform="translate(0 0.0141602)"
            />
          </clipPath>
        </defs>
      </svg>

      <Text size="p3">
        {f({
          id: 'expert.specialtyList.noResult',
          defaultMessage: 'No specialty found. Please try another keyword',
        })}
      </Text>
    </Stack>
  )
})
